import { motion } from 'framer-motion';
import { cn } from '@/lib/utils';
import wordmark from '@/assets/wntd-wordmark.svg';

interface FashionLoadingAnimationProps {
  className?: string;
}

export function FashionLoadingAnimation({ className }: FashionLoadingAnimationProps) {
  return (
    <div 
      className={cn(
        "absolute inset-0 overflow-hidden select-none bg-muted/30",
        className
      )}
    >
      {/* Subtle shimmer effect */}
      <motion.div
        className="absolute inset-0"
        style={{
          background: 'linear-gradient(90deg, transparent 0%, hsl(var(--primary) / 0.08) 50%, transparent 100%)',
          backgroundSize: '200% 100%',
        }}
        animate={{
          backgroundPosition: ['200% 0', '-200% 0'],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'linear',
        }}
      />
      
      {/* Soft pulsing background */}
      <motion.div
        className="absolute inset-0 bg-primary/5"
        animate={{
          opacity: [0.3, 0.6, 0.3],
        }}
        transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut',
        }}
      />

      {/* Central W logo */}
      <div className="absolute inset-0 flex items-center justify-center">
        <motion.img
          src={wordmark}
          alt="Loading"
          className="h-5 w-auto opacity-80"
          animate={{ 
            scale: [1, 1.1, 1],
            opacity: [0.6, 1, 0.6],
          }}
          transition={{ duration: 2, repeat: Infinity, ease: 'easeInOut' }}
        />
      </div>
    </div>
  );
}
